import { Fab } from "@material-ui/core"
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import DateRangeIcon from "@material-ui/icons/DateRange";
import OrderedMaterialsStatisticsDialog from "./OrderedMaterialsStatisticsDialog";
import { useState } from "react";
import { isUserInRole } from "../../security/UserRoles";
import { useKeycloak } from "@react-keycloak/web";

type Props = {
  buttonClasses: ClassNameMap;
}

const OrderedMaterialsStatisticsButton = (props: Props) => {
  const { keycloak } = useKeycloak();
  const [statisticsDialogOpen, setStatisticsDialogOpen] = useState<boolean>(false);

  const handleOrderedMaterialStatisticsButtonClicked = () => {
    setStatisticsDialogOpen(true);
  };

  const handleOrderedMaterialStatisticsDialogCloseClicked = () => {
    setStatisticsDialogOpen(false);
  }

  return <>
    { isUserInRole(keycloak, 'STATISTICS_ORDER_MATERIALS') &&
      <Fab
        aria-label="cleanup"
        className={ props.buttonClasses.button }
        color="primary"
        size="medium"
        onClick={ handleOrderedMaterialStatisticsButtonClicked }
      >
        <DateRangeIcon />
      </Fab>
    }
    <OrderedMaterialsStatisticsDialog
      open={ statisticsDialogOpen }
      onDialogClosed={ handleOrderedMaterialStatisticsDialogCloseClicked }/>
  </>
};

export default OrderedMaterialsStatisticsButton;